(() => {
  const GIFT_VARIANT_ID = 54880906215692;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  let syncing = false;
  let queued = false;

  const cartUrl = (path) => `${root}${path}`.replace(/\/{2,}/g, "/");

  async function refreshCartUI(cart) {
    const drawer = document.querySelector("m-cart-drawer");
    if (drawer && typeof drawer.onCartDrawerUpdate === "function") {
      drawer.onCartDrawerUpdate();
    }
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
  }

  async function syncGift() {
    if (syncing) {
      queued = true;
      return;
    }

    syncing = true;
    try {
      const cartResponse = await fetch(cartUrl("cart.js"), {
        headers: { Accept: "application/json", "X-Silkhouse-Gift": "1" },
      });
      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();
      const giftLines = cart.items.filter((item) => item.variant_id === GIFT_VARIANT_ID);
      const hasPaidItem = cart.items.some((item) => item.variant_id !== GIFT_VARIANT_ID);
      const giftQuantity = giftLines.reduce((total, item) => total + item.quantity, 0);
      const wantedQuantity = hasPaidItem ? 1 : 0;

      if (giftQuantity === wantedQuantity && giftLines.length <= 1) return;

      const updateResponse = await fetch(cartUrl("cart/update.js"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Silkhouse-Gift": "1",
        },
        body: JSON.stringify({ updates: { [GIFT_VARIANT_ID]: wantedQuantity } }),
      });
      if (!updateResponse.ok) return;

      const updatedCart = await updateResponse.json();
      await refreshCartUI(updatedCart);
    } catch (error) {
      console.error("Silkhouse auto-gift:", error);
    } finally {
      syncing = false;
      if (queued) {
        queued = false;
        syncGift();
      }
    }
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = function (input, options = {}) {
    const request = input instanceof Request ? input : null;
    const url = request ? request.url : String(input);
    const headers = new Headers(options.headers || (request && request.headers) || {});
    const isOwnRequest = headers.get("X-Silkhouse-Gift") === "1";
    const isCartMutation = /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url);

    return originalFetch(input, options).then((response) => {
      if (!isOwnRequest && isCartMutation) {
        setTimeout(syncGift, 150);
      }
      return response;
    });
  };

  document.addEventListener("DOMContentLoaded", syncGift);
  document.addEventListener("cart:updated", syncGift);
})();
